import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=3371210d&scoped=true&"
import script from "./uploads.vue?vue&type=script&lang=ts&"
export * from "./uploads.vue?vue&type=script&lang=ts&"
import style0 from "./uploads.vue?vue&type=style&index=0&id=3371210d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371210d",
  null
  
)

export default component.exports